<template>
  <div id="app">
    <Spinner :visible="$store.getters['ui/isLoading']" />
    <router-view/>
  </div>
</template>
<script>
import Spinner from './components/loader/Spinner.vue';

export default {
  name: 'App',
  components: {
    Spinner
  },
  mounted () {
  }

}
</script>
<style lang="scss">
  @import "./assets/scss/backend.scss";
</style>
